import { accountIdFormat } from "@redotech/redo-model/ids";
import { PriceBookRowSchema } from "@redotech/redo-model/price-book/price-book";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const getPriceBooks = unaryRpc({
  name: "getPriceBooks" as const,
  input: z.object({ accountId: accountIdFormat.schema }),
  output: z.object({ priceBooks: z.array(PriceBookRowSchema) }),
});
